import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionDetails, AccordionSummary, Grid, Tooltip, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Delete, Save } from '@mui/icons-material';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { Typography } from '@totalsoft/rocket-ui';
import CompetenceOrderRuleListItemComponent from './CompetenceOrderRuleListItemComponent';
import CompetenceOrderRuleListItemSummary from './CompetenceOrderRuleListItemSummary.js';

const CompetenceOrderRuleListComponent = ({
  competenceOrderRules,
  approvalTypeLevels,
  ruleStatuses,
  onSave,
  onPropertyChanged,
  onDelete,
  onExpandChange,
  validation
}) => {
  const { t } = useTranslation();

  return competenceOrderRules.map((item, idx) => {
    const header = <CompetenceOrderRuleListItemSummary competenceOrderRule={item} />;

    return (
      <Grid key={idx} item xs={12} sx={{ marginBottom: '35px!important' }}>
        <Accordion expanded={item.isExpanded} onChange={(_, isExpanded) => onExpandChange(isExpanded, idx)}>
          <AccordionSummary sx={{ width: '100%' }} expandIcon={<ExpandMoreIcon />}>
            {(item.isExpanded || (!item.isExpanded && !header)) && (
              <Grid container spacing={1} justifyContent='flex-end' onClick={event => event.stopPropagation()}>
                <Grid item>
                  <Tooltip title={t('CompetenceOrder.SaveChanges')}>
                    <div>
                      <IconButton
                        color='primary'
                        onClick={() => onSave(idx)}
                        disabled={!item.changed || !(validation[idx] |> isValid) || (validation |> getErrors) !== ''}
                      >
                        <Save />
                      </IconButton>
                    </div>
                  </Tooltip>
                </Grid>
                <Grid item>
                  <Tooltip title={t('Tooltips.CompetenceOrder.DeleteRule')}>
                    <IconButton color='primary' onClick={onDelete(idx)}>
                      <Delete />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            )}
            {!item.isExpanded && <div style={{ width: '100%' }}>{header}</div>}
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography color='error'>{validation |> getErrors}</Typography>
              </Grid>
              <CompetenceOrderRuleListItemComponent
                competenceOrderRule={item}
                approvalTypeLevels={approvalTypeLevels}
                ruleStatuses={ruleStatuses}
                index={idx}
                onPropertyChanged={onPropertyChanged}
                collectionValidation={validation}
              />
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    );
  });
};

CompetenceOrderRuleListComponent.propTypes = {
  competenceOrderRules: PropTypes.array.isRequired,
  approvalTypeLevels: PropTypes.array,
  ruleStatuses: PropTypes.array,
  onSave: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onExpandChange: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default CompetenceOrderRuleListComponent;
